import { ATP_API_URL } from "@config/apiconfig";
import apiClient from "@services/apiClient";

export const updatePasswordData = async (updatePasswordPayload) => {
  try {
    let url = ATP_API_URL.UPDATE_PASSWORD;
    const response = await apiClient.post(url, updatePasswordPayload);
    if (response?.data?.success) {
      return response.data;
    }
  } catch (error) {
    throw error;
  }
};
